/**
 * Function to get the avatar and the name of the participants of the conversations
 * @param {*} chats
 * @param {*} subscribers
 * @returns
 */
export const addChatParticipantInfo = (chats = [], subscribers = []) => {
  const updatedChat = chats.map((chat) => {
    const subscriber = subscribers.find(
      (sub) => String(sub._id) === String(chat.chatWithId)
    );
    if (subscriber) {
      return {
        ...chat,
        chatWithName: subscriber.name,
        avatar: subscriber.avatar,
      };
    }
    return chat;
  });

  return updatedChat;
};

/**
 * Sort conversations ascending o descending
 * @param {*} conversations
 * @param {*} sortOrder
 * @returns
 */
export const sortConversationsByName = (conversations, sortOrder = "asc") => {
  // Remove special characters
  const normalizeString = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const sortArray = (array) => {
    return array.sort((a, b) => {
      const nameA = normalizeString(
        a.chatWithName || a.subject || ""
      ).toLowerCase();
      const nameB = normalizeString(
        b.chatWithName || b.subject || ""
      ).toLowerCase();

      if (nameA < nameB) return sortOrder === "asc" ? -1 : 1;
      if (nameA > nameB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });
  };

  return {
    ...conversations,
    readChannels: sortArray(conversations.readChannels),
    readDirects: sortArray(conversations.readDirects),
    unreadChats: sortArray(conversations.unreadChats),
  };
};

/**
 * Sort conversations by most recent
 * @param {*} conversations
 * @returns
 */
export const sortByMostRecent = (conversations) => {
  const sortArray = (array) => {
    return array.sort((a, b) => {
      const timeA = a.lastMessageAt || 0;
      const timeB = b.lastMessageAt || 0;
      return timeB - timeA;
    });
  };

  return {
    ...conversations,
    readChannels: sortArray(conversations.readChannels),
    readDirects: sortArray(conversations.readDirects),
    unreadChats: sortArray(conversations.unreadChats),
  };
};

/**
 * Get the conversations filtered by name
 * @param {*} conversations
 */
export const getFilteredConversations = (filterValue, conversations) => {
  const filteredConversations = filterValue
    ? conversations.filter(
        (conv) =>
          conv.subject?.toLowerCase().startsWith(filterValue.toLowerCase()) ||
          conv.chatWithName?.toLowerCase().startsWith(filterValue.toLowerCase())
      )
    : conversations;
  return filteredConversations;
};

export const modifyConversation = async (api, body) => {
  await api(`modify-conversation`, {
    method: "PUT",
    body,
  });
};

export const getPushConversations = async (api, userId) => {
  const res = await api("push-chat-conversations", {
    query: { userId },
  });
  const resJSON = await res.json();
  const data = resJSON?.chats || {
    readChannels: [],
    readDirects: [],
    unreadChats: [],
    lastConversationId: null,
  };
  return data;
};

export const getPushConversation = async (api, conversationId) => {
  const res = await api("community-channel", {
    query: { conversationId },
  });
  const resJSON = await res.json();
  const data = resJSON?.conversation || null;
  return data;
};
